import Vue from 'vue'
import VueRouter from 'vue-router'

import NoPage from '@/views/NoPage.vue'
import Home from '@/views/Home/Home.vue'
import AccessPreRequestLoan from '@/views/PreRequestLoan/AccessPreRequestLoan.vue'
import PreRequestLoan from '@/views/PreRequestLoan/PreRequestLoan.vue'
import NoDebtCertificateRequest from '@/views/NoDebtCertificate/NoDebtCertificate.vue'
import NoDebtCertificateRequested from '@/views/NoDebtCertificate/NoDebtCertificateRequested.vue'
import CaptureBeneficiaries from '@/views/Beneficiarie/CaptureBeneficiaries.vue'
import BeneficiarieUpdateRequests from '@/views/Beneficiarie/BeneficiarieUpdateRequests.vue'
import RenounceSaving from '@/views/RenounceSaving/RenounceSaving.vue'
import RenounceSavingRequested from '@/views/RenounceSaving/RenounceSavingRequested.vue'
import RetirementRequest from '@/views/Retirement/RetirementRequest.vue'
import RetirementLanding from '@/views/Retirement/Landing.vue'
import RetirementRequested from '@/views/Retirement/RetirementRequested.vue'
import RefundForDiscount from '@/views/RefundForDiscount/RefundForDiscount.vue'
import RefundForDiscountRequested from '@/views/RefundForDiscount/RefundForDiscountRequested.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Home',
    component: NoPage
  },
  {
    path: '/loan-request',
    name: 'HomeLoanRequest',
    component: Home
  },
  {
    path: '/loan-request/access-pre-request-loan',
    name: 'AccessPreRequestLoan',
    component: AccessPreRequestLoan
  },
  {
    path: '/loan-request/pre-request-loan',
    name: 'PreRequestLoan', 
    component: PreRequestLoan
  },
  {
    path: '/no-debt-certificate/no-debt-certificate-request',
    name: 'NoDebtCertificateRequest',
    component: NoDebtCertificateRequest
  },
  {
    path: '/no-debt-certificate/no-debt-certificate-requested',
    name: 'NoDebtCertificateRequested',
    component: NoDebtCertificateRequested
  },
  {
    path: '/beneficiaries/capture-beneficiaries',
    name: 'CaptureBeneficiaries',
    component: CaptureBeneficiaries
  },
  {
    path: '/beneficiaries/beneficiarie-update-requests',
    name: 'BeneficiarieUpdateRequests',
    component: BeneficiarieUpdateRequests
  },
  {
    path: '/renounce-saving/renounce-saving-request',
    name: 'RenounceSavingRequest',
    component: RenounceSaving
  },
  {
    path: '/renounce-saving/renounce-saving-requested',
    name: 'RenounceSavingRequested',
    component: RenounceSavingRequested
  },
  {
    path: '/retirement/retirement-request',
    name: 'RetirementRequest',
    component: RetirementRequest
  },
  {
    path: '/retirement',
    name: 'RetirementLanding',
    component: RetirementLanding
  },
  {
    path: '/retirement/retirement-requested',
    name: 'RetirementRequested',
    component: RetirementRequested
  },
  {
    path: '/refund-for-discount/refund-for-discount-request',
    name: 'RefundForDiscountRequest',
    component: RefundForDiscount
  },
  {
    path: '/refund-for-discount/refund-for-discount-requested',
    name: 'RefundForDiscountRequested',
    component: RefundForDiscountRequested
  },
]

const router = new VueRouter({
  mode: 'history',
  routes
})

export default router
